define('app/views/modal',['require','./baseview','../models/Modal'],function(require) {

  var BaseView = require('./baseview');
  var Modal = require('../models/Modal');

	return BaseView.extend({

    view: 'modal',
    timeline: null,

    defaults: {
      scrimOpacity: 0.8,
      scrimCloses: true,
      escapeKeyCloses: true
    },

		events: {
      'click .scrim': 'onClickScrim',
      'click .close': 'onClickClose'
		},

		initialize: function(options) {
      BaseView.prototype.initialize.call(this, options);

      _.bindAll(this,
        'onClickClose',
        'onKeyDown'
      );
		},

    update: function(title, message, buttons){
      this.model.set({ title: title, message: message }, { silent: buttons ? true : false });
      if(buttons && buttons.length){
        this.model.set({ buttons: buttons });
      }
      return this;
    },

    show: function(){
      $('body').append(this.$el);

      if(!this.timeline) {
        this.timeline = new TimelineMax({ onComplete: this.afterShow, onReverseComplete: this.afterHide });
        this.timeline.append(TweenMax.fromTo(this.$el, 0, { display: 'none' }, { display: 'block' }));
        this.timeline.append(TweenMax.fromTo($('.scrim', this.$el), 0.3, { display: 'none', alpha: 0 }, { display: 'block', alpha: this.options.scrimOpacity }));
        this.timeline.append(TweenMax.fromTo($('.content', this.$el), 0.3, { display: 'none', alpha: 0, rotationX: '30deg', y: -50 }, { display: 'block', alpha: 1, rotationX: '0deg', y: 0, onStart: this.onResize, onStartScope: this }));
      }

      this.timeline.play();

      return this;
    },

    afterShow: function(){
      BaseView.prototype.afterShow.call(this);
      if(this.options.escapeKeyCloses) {
        $(document).on('keydown.modal', this.onKeyDown);
      }
    },

    hide: function(){
      this.timeline.reverse();
      return this;
    },

    afterHide: function(){
      BaseView.prototype.afterHide.call(this);
      $(document).off('keydown.modal');
    },

    onResize: function(e){
      var content = $('.content', this.$el);
      content.css({
        marginLeft: -content.width() / 2,
        marginTop: -content.height() / 2
      });
    },

    onClickScrim: function(e){
      if(this.options.scrimCloses){
        this.hide();
      }
    },

    onClickClose: function(e){
      this.hide();
    },

    onKeyDown: function(e){
      if(e.keyCode == 27){
        this.hide();
      }
    }

	});

});
